export const AllComponentsURL = "/all-components/";
export const PerFilterCountsURL = "/api/per-filter-counts/";
export const CountZabiegiApiURL = "/api/zabiegi-count/";
export const BannerCloseURL = "/banner-close/";
export const JDDDebuggerURL = "/components/";
export const SendContactMessageURL = "/contact-message/";
export const DisplayArticlesURL = "/czytelnia-aspazji/";
export const BlogArticleViewURL = (article_slug: string, article_id: string) =>
	`/czytelnia-aspazji/artykuly/${article_slug}/${article_id}/`;
BlogArticleViewURL.params = ["article_slug", "article_id"];
BlogArticleViewURL.rawURL = "/czytelnia-aspazji/artykuly/:article_slug/:article_id/";
export const ArticlesPerCategoryURL = (category_slug: string) =>
	`/czytelnia-aspazji/kategorie/${category_slug}/`;
ArticlesPerCategoryURL.params = ["category_slug"];
ArticlesPerCategoryURL.rawURL = "/czytelnia-aspazji/kategorie/:category_slug/";
export const HorizontalScrollerDemoURL = "/demos/horizontal-scroller/";
export const ShowFirstRowDemoURL = "/demos/show-first-row/";
export const SortableDemoURL = "/demos/sortable/";
export const AdminRedirectURL = "/dowodzenie/";
export const BannersListURL = "/dowodzenie/bannery/";
export const BannersDeleteAskURL = (id: string) =>
	`/dowodzenie/bannery/${id}/delete-ask/`;
BannersDeleteAskURL.params = ["id"];
BannersDeleteAskURL.rawURL = "/dowodzenie/bannery/:id/delete-ask/";
export const BannersDeleteURL = (id: string) => `/dowodzenie/bannery/${id}/delete/`;
BannersDeleteURL.params = ["id"];
BannersDeleteURL.rawURL = "/dowodzenie/bannery/:id/delete/";
export const BannersEditURL = (id: string) => `/dowodzenie/bannery/${id}/edit/`;
BannersEditURL.params = ["id"];
BannersEditURL.rawURL = "/dowodzenie/bannery/:id/edit/";
export const BannersCreateURL = "/dowodzenie/bannery/create/";
export const PriceGroupCRUDListURL = "/dowodzenie/cenniki/";
export const PriceGroupCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/cenniki/${id}/delete-ask/`;
PriceGroupCRUDDeleteAskURL.params = ["id"];
PriceGroupCRUDDeleteAskURL.rawURL = "/dowodzenie/cenniki/:id/delete-ask/";
export const PriceGroupCRUDDeleteURL = (id: string) =>
	`/dowodzenie/cenniki/${id}/delete/`;
PriceGroupCRUDDeleteURL.params = ["id"];
PriceGroupCRUDDeleteURL.rawURL = "/dowodzenie/cenniki/:id/delete/";
export const PriceGroupCRUDEditURL = (id: string) => `/dowodzenie/cenniki/${id}/edit/`;
PriceGroupCRUDEditURL.params = ["id"];
PriceGroupCRUDEditURL.rawURL = "/dowodzenie/cenniki/:id/edit/";
export const EditPricelistTableURL = (id: string) => `/dowodzenie/cenniki/${id}/table/`;
EditPricelistTableURL.params = ["id"];
EditPricelistTableURL.rawURL = "/dowodzenie/cenniki/:id/table/";
export const PriceGroupCRUDCreateURL = "/dowodzenie/cenniki/create/";
export const BlogArticlesListURL = "/dowodzenie/czytelnia/artykuly/";
export const EditArticleContentURL = (id: string) =>
	`/dowodzenie/czytelnia/artykuly/${id}/content/`;
EditArticleContentURL.params = ["id"];
EditArticleContentURL.rawURL = "/dowodzenie/czytelnia/artykuly/:id/content/";
export const EditArticleContentBelowURL = (id: string) =>
	`/dowodzenie/czytelnia/artykuly/${id}/content_below/`;
EditArticleContentBelowURL.params = ["id"];
EditArticleContentBelowURL.rawURL = "/dowodzenie/czytelnia/artykuly/:id/content_below/";
export const BlogArticlesDeleteAskURL = (id: string) =>
	`/dowodzenie/czytelnia/artykuly/${id}/delete-ask/`;
BlogArticlesDeleteAskURL.params = ["id"];
BlogArticlesDeleteAskURL.rawURL = "/dowodzenie/czytelnia/artykuly/:id/delete-ask/";
export const BlogArticlesDeleteURL = (id: string) =>
	`/dowodzenie/czytelnia/artykuly/${id}/delete/`;
BlogArticlesDeleteURL.params = ["id"];
BlogArticlesDeleteURL.rawURL = "/dowodzenie/czytelnia/artykuly/:id/delete/";
export const BlogArticlesEditURL = (id: string) =>
	`/dowodzenie/czytelnia/artykuly/${id}/edit/`;
BlogArticlesEditURL.params = ["id"];
BlogArticlesEditURL.rawURL = "/dowodzenie/czytelnia/artykuly/:id/edit/";
export const BlogArticlesCreateURL = "/dowodzenie/czytelnia/artykuly/create/";
export const ArticleCategoriesListURL = "/dowodzenie/czytelnia/kategorie/";
export const ArticleCategoriesDeleteURL = (id: string) =>
	`/dowodzenie/czytelnia/kategorie/${id}/delete/`;
ArticleCategoriesDeleteURL.params = ["id"];
ArticleCategoriesDeleteURL.rawURL = "/dowodzenie/czytelnia/kategorie/:id/delete/";
export const ArticleCategoriesCRUDEditURL = (id: string) =>
	`/dowodzenie/czytelnia/kategorie/${id}/edit/`;
ArticleCategoriesCRUDEditURL.params = ["id"];
ArticleCategoriesCRUDEditURL.rawURL = "/dowodzenie/czytelnia/kategorie/:id/edit/";
export const ArticleCategoriesCreateURL = "/dowodzenie/czytelnia/kategorie/create/";
export const GlobalsListURL = "/dowodzenie/dane-strony/";
export const GlobalsEditURL = (id: string) => `/dowodzenie/dane-strony/${id}/edit/`;
GlobalsEditURL.params = ["id"];
GlobalsEditURL.rawURL = "/dowodzenie/dane-strony/:id/edit/";
export const EncyclopediaEntriesCRUDListURL = "/dowodzenie/encyklopedia/";
export const EditEncyclopediaEntryContentURL = (id: string) =>
	`/dowodzenie/encyklopedia/${id}/content/`;
EditEncyclopediaEntryContentURL.params = ["id"];
EditEncyclopediaEntryContentURL.rawURL = "/dowodzenie/encyklopedia/:id/content/";
export const EncyclopediaEntriesCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/encyklopedia/${id}/delete-ask/`;
EncyclopediaEntriesCRUDDeleteAskURL.params = ["id"];
EncyclopediaEntriesCRUDDeleteAskURL.rawURL = "/dowodzenie/encyklopedia/:id/delete-ask/";
export const EncyclopediaEntriesCRUDDeleteURL = (id: string) =>
	`/dowodzenie/encyklopedia/${id}/delete/`;
EncyclopediaEntriesCRUDDeleteURL.params = ["id"];
EncyclopediaEntriesCRUDDeleteURL.rawURL = "/dowodzenie/encyklopedia/:id/delete/";
export const EncyclopediaEntriesCRUDEditURL = (id: string) =>
	`/dowodzenie/encyklopedia/${id}/edit/`;
EncyclopediaEntriesCRUDEditURL.params = ["id"];
EncyclopediaEntriesCRUDEditURL.rawURL = "/dowodzenie/encyklopedia/:id/edit/";
export const EncyclopediaEntriesCRUDCreateURL = "/dowodzenie/encyklopedia/create/";
export const TreatmentSubcategoriesCRUDListURL = "/dowodzenie/filtry/";
export const TreatmentSubcategoriesCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/filtry/${id}/delete-ask/`;
TreatmentSubcategoriesCRUDDeleteAskURL.params = ["id"];
TreatmentSubcategoriesCRUDDeleteAskURL.rawURL = "/dowodzenie/filtry/:id/delete-ask/";
export const TreatmentSubcategoriesCRUDDeleteURL = (id: string) =>
	`/dowodzenie/filtry/${id}/delete/`;
TreatmentSubcategoriesCRUDDeleteURL.params = ["id"];
TreatmentSubcategoriesCRUDDeleteURL.rawURL = "/dowodzenie/filtry/:id/delete/";
export const TreatmentSubcategoriesCRUDEditURL = (id: string) =>
	`/dowodzenie/filtry/${id}/edit/`;
TreatmentSubcategoriesCRUDEditURL.params = ["id"];
TreatmentSubcategoriesCRUDEditURL.rawURL = "/dowodzenie/filtry/:id/edit/";
export const TreatmentSubcategoriesCRUDCreateURL = "/dowodzenie/filtry/create/";
export const DisplaySearchHistoryURL = "/dowodzenie/historia-wyszukiwania/";
export const PropertyIconsCRUDListURL = "/dowodzenie/ikony-cech/";
export const PropertyIconsCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/ikony-cech/${id}/delete-ask/`;
PropertyIconsCRUDDeleteAskURL.params = ["id"];
PropertyIconsCRUDDeleteAskURL.rawURL = "/dowodzenie/ikony-cech/:id/delete-ask/";
export const PropertyIconsCRUDDeleteURL = (id: string) =>
	`/dowodzenie/ikony-cech/${id}/delete/`;
PropertyIconsCRUDDeleteURL.params = ["id"];
PropertyIconsCRUDDeleteURL.rawURL = "/dowodzenie/ikony-cech/:id/delete/";
export const PropertyIconsCRUDEditURL = (id: string) =>
	`/dowodzenie/ikony-cech/${id}/edit/`;
PropertyIconsCRUDEditURL.params = ["id"];
PropertyIconsCRUDEditURL.rawURL = "/dowodzenie/ikony-cech/:id/edit/";
export const PropertyIconsCRUDCreateURL = "/dowodzenie/ikony-cech/create/";
export const ContactURL = "/dowodzenie/kontakt/";
export const ContactCsvURL = "/dowodzenie/kontakt/csv/";
export const AdminLoginURL = "/dowodzenie/login/";
export const MegamenuEntriesListURL = "/dowodzenie/megamenu/";
export const MegamenuEntriesDeleteAskURL = (id: string) =>
	`/dowodzenie/megamenu/${id}/delete-ask/`;
MegamenuEntriesDeleteAskURL.params = ["id"];
MegamenuEntriesDeleteAskURL.rawURL = "/dowodzenie/megamenu/:id/delete-ask/";
export const MegamenuEntriesDeleteURL = (id: string) =>
	`/dowodzenie/megamenu/${id}/delete/`;
MegamenuEntriesDeleteURL.params = ["id"];
MegamenuEntriesDeleteURL.rawURL = "/dowodzenie/megamenu/:id/delete/";
export const MegamenuEntriesEditURL = (id: string) => `/dowodzenie/megamenu/${id}/edit/`;
MegamenuEntriesEditURL.params = ["id"];
MegamenuEntriesEditURL.rawURL = "/dowodzenie/megamenu/:id/edit/";
export const MegamenuEntriesCreateURL = "/dowodzenie/megamenu/create/";
export const QuickFiltersCRUDListURL = "/dowodzenie/na-skroty/";
export const QuickFiltersCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/na-skroty/${id}/delete-ask/`;
QuickFiltersCRUDDeleteAskURL.params = ["id"];
QuickFiltersCRUDDeleteAskURL.rawURL = "/dowodzenie/na-skroty/:id/delete-ask/";
export const QuickFiltersCRUDDeleteURL = (id: string) =>
	`/dowodzenie/na-skroty/${id}/delete/`;
QuickFiltersCRUDDeleteURL.params = ["id"];
QuickFiltersCRUDDeleteURL.rawURL = "/dowodzenie/na-skroty/:id/delete/";
export const QuickFiltersCRUDEditURL = (id: string) =>
	`/dowodzenie/na-skroty/${id}/edit/`;
QuickFiltersCRUDEditURL.params = ["id"];
QuickFiltersCRUDEditURL.rawURL = "/dowodzenie/na-skroty/:id/edit/";
export const QuickFiltersCRUDCreateURL = "/dowodzenie/na-skroty/create/";
export const TabTitleOverridesCRUDListURL = "/dowodzenie/nadpisz-tytul-karty/";
export const TabTitleOverridesCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/nadpisz-tytul-karty/${id}/delete-ask/`;
TabTitleOverridesCRUDDeleteAskURL.params = ["id"];
TabTitleOverridesCRUDDeleteAskURL.rawURL =
	"/dowodzenie/nadpisz-tytul-karty/:id/delete-ask/";
export const TabTitleOverridesCRUDDeleteURL = (id: string) =>
	`/dowodzenie/nadpisz-tytul-karty/${id}/delete/`;
TabTitleOverridesCRUDDeleteURL.params = ["id"];
TabTitleOverridesCRUDDeleteURL.rawURL = "/dowodzenie/nadpisz-tytul-karty/:id/delete/";
export const TabTitleOverridesCRUDEditURL = (id: string) =>
	`/dowodzenie/nadpisz-tytul-karty/${id}/edit/`;
TabTitleOverridesCRUDEditURL.params = ["id"];
TabTitleOverridesCRUDEditURL.rawURL = "/dowodzenie/nadpisz-tytul-karty/:id/edit/";
export const TabTitleOverridesCRUDCreateURL = "/dowodzenie/nadpisz-tytul-karty/create/";
export const OpinionsCRUDListURL = "/dowodzenie/opinie/";
export const OpinionsCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/opinie/${id}/delete-ask/`;
OpinionsCRUDDeleteAskURL.params = ["id"];
OpinionsCRUDDeleteAskURL.rawURL = "/dowodzenie/opinie/:id/delete-ask/";
export const OpinionsCRUDDeleteURL = (id: string) => `/dowodzenie/opinie/${id}/delete/`;
OpinionsCRUDDeleteURL.params = ["id"];
OpinionsCRUDDeleteURL.rawURL = "/dowodzenie/opinie/:id/delete/";
export const OpinionsCRUDEditURL = (id: string) => `/dowodzenie/opinie/${id}/edit/`;
OpinionsCRUDEditURL.params = ["id"];
OpinionsCRUDEditURL.rawURL = "/dowodzenie/opinie/:id/edit/";
export const OpinionsCRUDCreateURL = "/dowodzenie/opinie/create/";
export const AdminPanelURL = "/dowodzenie/panel/";
export const EmployeesCRUDListURL = "/dowodzenie/personel/";
export const DeleteEmployeeURL = (id: string) => `/dowodzenie/personel/${id}/delete/`;
DeleteEmployeeURL.params = ["id"];
DeleteEmployeeURL.rawURL = "/dowodzenie/personel/:id/delete/";
export const EmployeesCRUDEditURL = (id: string) => `/dowodzenie/personel/${id}/edit/`;
EmployeesCRUDEditURL.params = ["id"];
EmployeesCRUDEditURL.rawURL = "/dowodzenie/personel/:id/edit/";
export const EmployeesCRUDCreateURL = "/dowodzenie/personel/create/";
export const SearchPlaceholderEditURL = "/dowodzenie/placeholder-wyszukiwania/";
export const RedirectsCRUDListURL = "/dowodzenie/przekierowania/";
export const RedirectsCRUDDeleteURL = (id: string) =>
	`/dowodzenie/przekierowania/${id}/delete/`;
RedirectsCRUDDeleteURL.params = ["id"];
RedirectsCRUDDeleteURL.rawURL = "/dowodzenie/przekierowania/:id/delete/";
export const RedirectsCRUDEditURL = (id: string) =>
	`/dowodzenie/przekierowania/${id}/edit/`;
RedirectsCRUDEditURL.params = ["id"];
RedirectsCRUDEditURL.rawURL = "/dowodzenie/przekierowania/:id/edit/";
export const RedirectsCRUDCreateURL = "/dowodzenie/przekierowania/create/";
export const RobotsDashboardURL = "/dowodzenie/robots-dashboard/";
export const SitemapEditURL = "/dowodzenie/sitemap/";
export const FooterLinksListURL = "/dowodzenie/stopka/";
export const FooterLinksDeleteAskURL = (id: string) =>
	`/dowodzenie/stopka/${id}/delete-ask/`;
FooterLinksDeleteAskURL.params = ["id"];
FooterLinksDeleteAskURL.rawURL = "/dowodzenie/stopka/:id/delete-ask/";
export const FooterLinksDeleteURL = (id: string) => `/dowodzenie/stopka/${id}/delete/`;
FooterLinksDeleteURL.params = ["id"];
FooterLinksDeleteURL.rawURL = "/dowodzenie/stopka/:id/delete/";
export const FooterLinksEditURL = (id: string) => `/dowodzenie/stopka/${id}/edit/`;
FooterLinksEditURL.params = ["id"];
FooterLinksEditURL.rawURL = "/dowodzenie/stopka/:id/edit/";
export const FooterLinksCreateURL = "/dowodzenie/stopka/create/";
export const PageCRUDListURL = "/dowodzenie/strony/";
export const EditPageJDDContentURL = (id: string) => `/dowodzenie/strony/${id}/content/`;
EditPageJDDContentURL.params = ["id"];
EditPageJDDContentURL.rawURL = "/dowodzenie/strony/:id/content/";
export const PageCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/strony/${id}/delete-ask/`;
PageCRUDDeleteAskURL.params = ["id"];
PageCRUDDeleteAskURL.rawURL = "/dowodzenie/strony/:id/delete-ask/";
export const PageCRUDDeleteURL = (id: string) => `/dowodzenie/strony/${id}/delete/`;
PageCRUDDeleteURL.params = ["id"];
PageCRUDDeleteURL.rawURL = "/dowodzenie/strony/:id/delete/";
export const PageCRUDEditURL = (id: string) => `/dowodzenie/strony/${id}/edit/`;
PageCRUDEditURL.params = ["id"];
PageCRUDEditURL.rawURL = "/dowodzenie/strony/:id/edit/";
export const PageCRUDCreateURL = "/dowodzenie/strony/create/";
export const SearchSuggestionsCRUDListURL = "/dowodzenie/sugerowane-wyszukiwania/";
export const SearchSuggestionsCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/sugerowane-wyszukiwania/${id}/delete-ask/`;
SearchSuggestionsCRUDDeleteAskURL.params = ["id"];
SearchSuggestionsCRUDDeleteAskURL.rawURL =
	"/dowodzenie/sugerowane-wyszukiwania/:id/delete-ask/";
export const SearchSuggestionsCRUDDeleteURL = (id: string) =>
	`/dowodzenie/sugerowane-wyszukiwania/${id}/delete/`;
SearchSuggestionsCRUDDeleteURL.params = ["id"];
SearchSuggestionsCRUDDeleteURL.rawURL = "/dowodzenie/sugerowane-wyszukiwania/:id/delete/";
export const SearchSuggestionsCRUDEditURL = (id: string) =>
	`/dowodzenie/sugerowane-wyszukiwania/${id}/edit/`;
SearchSuggestionsCRUDEditURL.params = ["id"];
SearchSuggestionsCRUDEditURL.rawURL = "/dowodzenie/sugerowane-wyszukiwania/:id/edit/";
export const SearchSuggestionsCRUDCreateURL =
	"/dowodzenie/sugerowane-wyszukiwania/create/";
export const SeoDescriptionsCRUDListURL = "/dowodzenie/teksty-seo/";
export const SeoDescriptionsCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/teksty-seo/${id}/delete-ask/`;
SeoDescriptionsCRUDDeleteAskURL.params = ["id"];
SeoDescriptionsCRUDDeleteAskURL.rawURL = "/dowodzenie/teksty-seo/:id/delete-ask/";
export const SeoDescriptionsCRUDDeleteURL = (id: string) =>
	`/dowodzenie/teksty-seo/${id}/delete/`;
SeoDescriptionsCRUDDeleteURL.params = ["id"];
SeoDescriptionsCRUDDeleteURL.rawURL = "/dowodzenie/teksty-seo/:id/delete/";
export const SeoDescriptionsCRUDEditURL = (id: string) =>
	`/dowodzenie/teksty-seo/${id}/edit/`;
SeoDescriptionsCRUDEditURL.params = ["id"];
SeoDescriptionsCRUDEditURL.rawURL = "/dowodzenie/teksty-seo/:id/edit/";
export const SeoDescriptionsCRUDCreateURL = "/dowodzenie/teksty-seo/create/";
export const UsersCRUDListURL = "/dowodzenie/uzytkownicy/";
export const UsersCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/uzytkownicy/${id}/delete-ask/`;
UsersCRUDDeleteAskURL.params = ["id"];
UsersCRUDDeleteAskURL.rawURL = "/dowodzenie/uzytkownicy/:id/delete-ask/";
export const UsersCRUDDeleteURL = (id: string) => `/dowodzenie/uzytkownicy/${id}/delete/`;
UsersCRUDDeleteURL.params = ["id"];
UsersCRUDDeleteURL.rawURL = "/dowodzenie/uzytkownicy/:id/delete/";
export const UsersCRUDEditURL = (id: string) => `/dowodzenie/uzytkownicy/${id}/edit/`;
UsersCRUDEditURL.params = ["id"];
UsersCRUDEditURL.rawURL = "/dowodzenie/uzytkownicy/:id/edit/";
export const ManageRolesURL = (user_id: string) =>
	`/dowodzenie/uzytkownicy/${user_id}/uprawnienia/`;
ManageRolesURL.params = ["user_id"];
ManageRolesURL.rawURL = "/dowodzenie/uzytkownicy/:user_id/uprawnienia/";
export const UsersCRUDCreateURL = "/dowodzenie/uzytkownicy/create/";
export const TreatmentsCRUDListURL = "/dowodzenie/zabiegi/";
export const TreatmentsCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/zabiegi/${id}/delete-ask/`;
TreatmentsCRUDDeleteAskURL.params = ["id"];
TreatmentsCRUDDeleteAskURL.rawURL = "/dowodzenie/zabiegi/:id/delete-ask/";
export const TreatmentsCRUDDeleteURL = (id: string) =>
	`/dowodzenie/zabiegi/${id}/delete/`;
TreatmentsCRUDDeleteURL.params = ["id"];
TreatmentsCRUDDeleteURL.rawURL = "/dowodzenie/zabiegi/:id/delete/";
export const TreatmentsCRUDEditURL = (id: string) => `/dowodzenie/zabiegi/${id}/edit/`;
TreatmentsCRUDEditURL.params = ["id"];
TreatmentsCRUDEditURL.rawURL = "/dowodzenie/zabiegi/:id/edit/";
export const EditTreatmentDescriptionURL = (id: string) =>
	`/dowodzenie/zabiegi/${id}/opis/`;
EditTreatmentDescriptionURL.params = ["id"];
EditTreatmentDescriptionURL.rawURL = "/dowodzenie/zabiegi/:id/opis/";
export const TreatmentBannersCRUDListURL = "/dowodzenie/zabiegi/bannery/";
export const TreatmentBannersCRUDDeleteAskURL = (id: string) =>
	`/dowodzenie/zabiegi/bannery/${id}/delete-ask/`;
TreatmentBannersCRUDDeleteAskURL.params = ["id"];
TreatmentBannersCRUDDeleteAskURL.rawURL = "/dowodzenie/zabiegi/bannery/:id/delete-ask/";
export const TreatmentBannersCRUDDeleteURL = (id: string) =>
	`/dowodzenie/zabiegi/bannery/${id}/delete/`;
TreatmentBannersCRUDDeleteURL.params = ["id"];
TreatmentBannersCRUDDeleteURL.rawURL = "/dowodzenie/zabiegi/bannery/:id/delete/";
export const TreatmentBannersCRUDEditURL = (id: string) =>
	`/dowodzenie/zabiegi/bannery/${id}/edit/`;
TreatmentBannersCRUDEditURL.params = ["id"];
TreatmentBannersCRUDEditURL.rawURL = "/dowodzenie/zabiegi/bannery/:id/edit/";
export const TreatmentBannersCRUDCreateURL = "/dowodzenie/zabiegi/bannery/create/";
export const TreatmentsCRUDCreateURL = "/dowodzenie/zabiegi/create/";
export const TreatmentSortURL = "/dowodzenie/zabiegi/sort/";
export const ViewEncyclopediaIndexURL = "/encyklopedia/";
export const ViewEncyclopediaEntryURL = (ency_slug: string, ency_id: string) =>
	`/encyklopedia/${ency_slug}/${ency_id}/`;
ViewEncyclopediaEntryURL.params = ["ency_slug", "ency_id"];
ViewEncyclopediaEntryURL.rawURL = "/encyklopedia/:ency_slug/:ency_id/";
export const FilterTreatmentsURL = "/filter/";
export const FullscreenMenuDemoURL = "/fullscreen-menu-demo/";
export const LogoutURL = "/logout/";
export const NewsletterSignupURL = "/newsletter-signup/";
export const OpinionsURL = "/opinie/";
export const EmployeeViewURL = (employee_id: string, slug: string) =>
	`/personel/${employee_id}/${slug}/`;
EmployeeViewURL.params = ["employee_id", "slug"];
EmployeeViewURL.rawURL = "/personel/:employee_id/:slug/";
export const SearchHandlerURL = "/search-handler/";
export const SignInURL = "/signIn/";
export const SearchResultsURL = (query: string) => `/szukaj/${query}/`;
SearchResultsURL.params = ["query"];
SearchResultsURL.rawURL = "/szukaj/:query/";
export const TabsDemoURL = "/tabs-demo/";
export const RedirectToMainZabiegiViewURL = "/zabieg/";
export const ShowTreatmentURL = (slug: string, treatment_id: string) =>
	`/zabieg/${slug}/${treatment_id}/`;
ShowTreatmentURL.params = ["slug", "treatment_id"];
ShowTreatmentURL.rawURL = "/zabieg/:slug/:treatment_id/";
